import { z } from "zod";
import { BaseOutputSchema } from "../BaseOutput";

export const GetExecutedReportGroupsOutputSchema = BaseOutputSchema.extend({
    groups: z.array(z.string()),
});

export type GetExecutedReportGroupsOutput = z.infer<typeof GetExecutedReportGroupsOutputSchema>;